import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { logger } from 'app/core/utils/console';

@Component({
  selector: 'app-modal-ler-pdf',
  templateUrl: './modal-ler-pdf.component.html',
  styleUrls: ['./modal-ler-pdf.component.scss']
})
export class ModalLerPdfComponent implements OnInit {

  selectedFile: File | null = null;
  selectedTrimestre: number | null = null;
  errorMessage: string = '';
  maxFileSize = 15 * 1024 * 1024; // 15MB em bytes
  isDragOver: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { tipo?: 'exame' | 'ultrasom' } | null,
    public dialogRef: MatDialogRef<ModalLerPdfComponent>
  ) { }

  ngOnInit() {}

  onFileSelected(event: any): void {
    const file = event.target.files[0];
    this.processFile(file);
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer && event.dataTransfer.files;
    if (files && files.length > 0) {
      const file = files[0];
      this.processFile(file);
    }
  }

  private processFile(file: File): void {
    this.errorMessage = '';

    if (file) {
      // Validar se é PDF
      if (file.type !== 'application/pdf') {
        this.errorMessage = 'Por favor, selecione apenas arquivos PDF.';
        this.selectedFile = null;
        return;
      }

      // Validar tamanho do arquivo
      if (file.size > this.maxFileSize) {
        this.errorMessage = 'O arquivo deve ter no máximo 15MB.';
        this.selectedFile = null;
        return;
      }

      logger.log('Arquivo selecionado:', file);

      this.selectedFile = file;
    }
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  get requiresTrimestre(): boolean {
    return this.data && this.data.tipo === 'exame' ? true : false;
  }

  get canSubmit(): boolean {
    if (!this.selectedFile || !!this.errorMessage) return false;
    if (this.requiresTrimestre && !this.selectedTrimestre) return false;
    return true;
  }

  Salvar(): void {
    if (!this.selectedFile) {
      this.errorMessage = 'Por favor, selecione um arquivo PDF.';
      return;
    }
    if (this.requiresTrimestre && !this.selectedTrimestre) {
      this.errorMessage = 'Por favor, selecione o trimestre.';
      return;
    }

    // Criar FormData com o arquivo
    const formData = new FormData();
    formData.append('pdf', this.selectedFile, this.selectedFile.name);

    logger.log('FormData preparado para envio:', formData);

    // Retornar o FormData através do dialogRef
    this.dialogRef.close({
      formData: formData,
      file: this.selectedFile,
      selectedTrimestre: this.selectedTrimestre
    });
  }
}
